import { useHistory } from 'react-router-dom';

import MuteImg from '../../images/mute.svg';
import MuteActiveImg from '../../images/mute-active.svg';
import CamOffImg from '../../images/cam-off.svg';
import CamOffActiveImg from '../../images/cam-off-active.svg';
import ScreenShareImg from '../../images/screenshare.svg';
import ScreenShareActiveImg from '../../images/screenshare-active.svg';
import EndCallImg from '../../images/end-call.svg';
import {
  DestroySessionActionCreator,
  DetachPluginActionCreator,
  LeaveRoomActionCreator,
  LogoutActionCreator,
  ToggleMuteAudioActionCreator,
  ToggleMuteVideoActionCreator,
  ToggleScreenSharingActionCreator,
} from '../actionCreators';

export type CallScreenControlsStateProps = {
  muteAudio: boolean;
  muteVideo: boolean;
  screenshare: boolean;
};

export type CallScreenControlsDispatchProps = {
  destroySession: DestroySessionActionCreator;
  detachPlugin: DetachPluginActionCreator;
  leaveRoom: LeaveRoomActionCreator;
  logout: LogoutActionCreator;
  toggleMuteAudio: ToggleMuteAudioActionCreator;
  toggleMuteVideo: ToggleMuteVideoActionCreator;
  toggleScreenSharing: ToggleScreenSharingActionCreator;
};

type CallScreenControlsProps = CallScreenControlsStateProps &
  CallScreenControlsDispatchProps;

export default function CallScreenControls(
  props: CallScreenControlsProps
): JSX.Element {
  const {
    destroySession,
    detachPlugin,
    leaveRoom,
    logout,
    muteAudio,
    muteVideo,
    screenshare,
    toggleMuteAudio,
    toggleMuteVideo,
    toggleScreenSharing,
  } = props;

  const history = useHistory();
  const logoutAndRedirect = () => logout(() => history.replace(''));
  const destroySessionAndLogout = () =>
    destroySession({
      then: logoutAndRedirect,
      catch: logoutAndRedirect,
    });
  const detachPluginAndDestroySession = () =>
    detachPlugin({
      then: destroySessionAndLogout,
      catch: destroySessionAndLogout,
    });
  const endCall = () =>
    leaveRoom({
      then: detachPluginAndDestroySession,
      catch: detachPluginAndDestroySession,
    });

  return (
    <div className="controls">
      <div className="control">
        <button id="toggleMuteAudio" onClick={toggleMuteAudio}>
          {muteAudio ? <img src={MuteActiveImg} /> : <img src={MuteImg} />}
        </button>
        <span>{muteAudio ? 'Unmute' : 'Mute'}</span>
      </div>
      <div className="control">
        <button id="toggleMuteVideo" onClick={toggleMuteVideo}>
          {muteVideo ? <img src={CamOffActiveImg} /> : <img src={CamOffImg} />}
        </button>
        <span>Turn {muteVideo ? 'on' : 'off'} cam</span>
      </div>
      {'getDisplayMedia' in window.navigator.mediaDevices ? (
        <div className="control">
          <button id="toggleScreenSharing" onClick={toggleScreenSharing}>
            {screenshare ? (
              <img src={ScreenShareActiveImg} />
            ) : (
              <img src={ScreenShareImg} />
            )}
          </button>
          <span>{screenshare ? 'Stop Sharing' : 'Share Screen'}</span>
        </div>
      ) : null}
      <div className="control">
        <button id="endCall" onClick={endCall}>
          <img src={EndCallImg} />
        </button>
        <span>End Call</span>
      </div>
    </div>
  );
}
